import type { ReactNode } from "react";
import { FormLabel } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

type Props = {
  label: ReactNode;
  className?: string;
  readOnly?: boolean;
  subField?: boolean;
  required?: boolean;
};
const PlanFieldLabel = ({
  readOnly,
  label,
  className,
  subField,
  required,
}: Props) => (
  <FormLabel
    className={getClasses(
      styles["plan-field-label"],
      readOnly && styles["plan-field-label--readOnly"],
      subField && styles["plan-field-label--sub-field"],
      className,
    )}
  >
    {label}
    {!readOnly && required && (
      <span className={styles["plan-field-label__required"]}>{"*"}</span>
    )}
  </FormLabel>
);

export default PlanFieldLabel;
